<template>
  <b-card no-body class="tax-form-card mt-2">
    <div class="tax-section">
      <h6 class="section-label mt-0">
        <feather-icon icon="CreditCardIcon" size="13" class="mr-50" />Cashier Cheque (Closing Statement)
      </h6>

      <template v-for="(group, index) in chequeGroups">
        <cheque-group
          :key="group.id"
          :title="group.title"
          :editable-title="group.kind === 'custom'"
          :removable="group.kind === 'custom'"
          :kind="group.kind"
          :cheques="group.cheques"
          :target="targetFor(group.kind)"
          :target-label="targetLabelForKind(group.kind)"
          :manual-last="group.manualLast"
          @update:cheques="v => updateGroup(index, { cheques: v })"
          @update:manualLast="v => updateGroup(index, { manualLast: v })"
          @update:title="v => updateGroup(index, { title: v })"
          @remove-group="removeGroup(index)"
        />
        <hr v-if="index < chequeGroups.length - 1" :key="'hr-' + group.id" />
      </template>

      <hr />
      <b-button variant="outline-secondary" size="sm" @click="addCustomGroup">
        <feather-icon icon="PlusIcon" size="13" class="mr-25" />Add Cheque Group
      </b-button>
      <small class="text-muted d-block mt-25">
        For anything not covered above — a lawyer's fee, a rebate, a co-agent split — add a group and
        name it yourself.
      </small>
    </div>
  </b-card>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
import ChequeGroup from './ChequeGroup.vue'
import { targetLabelForKind, createCustomChequeGroup } from '../chequeGroups'

export default {
  components: { BCard, BButton, ChequeGroup },
  props: {
    chequeGroups: { type: Array, required: true },
    govtTotal: { type: Number, default: 0 },
    sellerNetTotal: { type: Number, default: 0 },
    commissionTotal: { type: Number, default: 0 },
  },
  methods: {
    targetLabelForKind,
    targetFor(kind) {
      if (kind === 'government') return this.govtTotal
      if (kind === 'seller') return this.sellerNetTotal
      if (kind === 'agent') return this.commissionTotal
      return 0
    },
    updateGroup(index, patch) {
      const updated = this.chequeGroups.map((g, i) => (i === index ? { ...g, ...patch } : g))
      this.$emit('update:chequeGroups', updated)
    },
    addCustomGroup() {
      this.$emit('update:chequeGroups', [...this.chequeGroups, createCustomChequeGroup()])
    },
    removeGroup(index) {
      const updated = this.chequeGroups.filter((_, i) => i !== index)
      this.$emit('update:chequeGroups', updated)
    },
  },
}
</script>
